var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.132507,
    y: 0.825195,
    width: 57.3494,
    height: 57.3494,
    rx: 28.6747,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5475 20.078C40.4358 20.0665 40.3232 20.0665 40.2116 20.078H17.2718C17.1248 20.0802 16.9787 20.1023 16.8376 20.1435L28.6761 31.9329L40.5475 20.078Z",
    fill: "#28720F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.76 21.217L29.8314 33.0966C29.5244 33.4017 29.1091 33.573 28.6762 33.573C28.2433 33.573 27.828 33.4017 27.521 33.0966L15.6988 21.3072C15.6625 21.4407 15.6432 21.5784 15.6415 21.7168V38.1023C15.6415 38.5369 15.8141 38.9537 16.1214 39.261C16.4287 39.5683 16.8455 39.7409 17.28 39.7409H40.2198C40.6544 39.7409 41.0711 39.5683 41.3784 39.261C41.6857 38.9537 41.8583 38.5369 41.8583 38.1023V21.7168C41.8518 21.5461 41.8187 21.3775 41.76 21.217ZM18.4024 38.1023H17.2636V36.9308L23.2198 31.0238L24.375 32.179L18.4024 38.1023ZM40.2034 38.1023H39.0564L33.0839 32.179L34.2391 31.0238L40.1952 36.9308L40.2034 38.1023Z",
    fill: "#28720F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3bc8ad46c9dafd795436d756c6a32095.svg";
export { ForwardRef as ReactComponent };